import eventManger from '../utilities/EventManager';
import _ from 'lodash';

export const PARTNER_USERS_EVENTS = {
  NEW_PRE_DIALOG: _.uniqueId('pu_new_pre_dialog'), //新規作成誤登録防止ダイアログ
  NEW_DIALOG: _.uniqueId('pu_new_dialog'), //新規登録ダイアログ
};

class PartnerUsersEventManager {
  constructor() {
    for (let key in PARTNER_USERS_EVENTS) {
      eventManger.registerEvent(PARTNER_USERS_EVENTS[key]);
    }
  }

  removeAll() {
    for (let key in PARTNER_USERS_EVENTS) {
      eventManger.deleteEvent(PARTNER_USERS_EVENTS[key]);
    }
  }
}

const PartnerUsersEventMg = new PartnerUsersEventManager();
export default PartnerUsersEventMg;



// WEBPACK FOOTER //
// ./src/components/PartnerUsersEvents.js